import React from 'react'
import { useTranslation } from 'react-i18next'
import { HiSearch, HiX } from 'react-icons/hi'

/**
 * SearchBar Component
 * Search input for filtering videos
 */
const SearchBar = ({ value, onChange }) => {
  const { t } = useTranslation()

  const handleClear = () => {
    onChange('')
  }

  return (
    <div className="relative">
      <div className="relative">
        <HiSearch className="absolute start-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('tutorials.search.placeholder')}
          className="w-full ps-12 pe-12 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#29AECB] focus:border-transparent transition-all"
        />
        {value && (
          <button
            onClick={handleClear}
            className="absolute end-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label={t('tutorials.search.clear')}
          >
            <HiX className="w-5 h-5" />
          </button>
        )}
      </div>
      {value && (
        <div className="mt-2 text-sm text-gray-600">
          {t('tutorials.search.searchingFor')} <span className="font-medium text-[#29AECB]">"{value}"</span>
        </div>
      )}
    </div>
  )
}

export default SearchBar
